export default function Footer() {
  return (
    <footer id="footer" className="bg-foreground-900 text-background-100">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6 py-14 md:py-20">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 mb-12">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 rounded-lg bg-primary-500 flex items-center justify-center">
                <i className="ri-flashlight-line text-background-50 text-base"></i>
              </div>
              <span className="font-heading text-xl font-bold text-background-50">爆料网</span>
            </div>
            <p className="text-sm text-foreground-400 leading-relaxed mb-4">
              爆料网是集51爆料网、91爆料网等热门来源的一站式吃瓜爆料平台，提供每日最新爆料内容与稳定访问入口，解决9-11爆料网打不开问题，让精彩永不中断。
            </p>
            <div className="flex items-center gap-3">
              <a href="#hero" className="w-9 h-9 rounded-lg bg-foreground-800 flex items-center justify-center text-foreground-300 hover:bg-primary-500 hover:text-background-50 transition-colors">
                <i className="ri-wechat-line text-base"></i>
              </a>
              <a href="#hero" className="w-9 h-9 rounded-lg bg-foreground-800 flex items-center justify-center text-foreground-300 hover:bg-primary-500 hover:text-background-50 transition-colors">
                <i className="ri-weibo-line text-base"></i>
              </a>
              <a href="#hero" className="w-9 h-9 rounded-lg bg-foreground-800 flex items-center justify-center text-foreground-300 hover:bg-primary-500 hover:text-background-50 transition-colors">
                <i className="ri-telegram-line text-base"></i>
              </a>
            </div>
          </div>

          <div>
            <h3 className="font-heading text-base text-background-50 mb-4">快速导航</h3>
            <ul className="space-y-2.5">
              <li><a href="#updates" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors">最新爆料快讯</a></li>
              <li><a href="#carousel" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors">焦点爆料专题</a></li>
              <li><a href="#cards" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors">热门爆料卡片</a></li>
              <li><a href="#ranking" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors">爆料热度榜</a></li>
              <li><a href="#faq" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors">常见疑问解答</a></li>
            </ul>
          </div>

          <div>
            <h3 className="font-heading text-base text-background-50 mb-4">热门话题</h3>
            <ul className="space-y-2.5">
              <li><a href="#topics" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors">#娱乐圈大瓜</a></li>
              <li><a href="#topics" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors">#互联网裁员</a></li>
              <li><a href="#topics" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors">#食品安全</a></li>
              <li><a href="#topics" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors">#股市风云</a></li>
              <li><a href="#topics" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors">#体育争议</a></li>
            </ul>
          </div>

          <div>
            <h3 className="font-heading text-base text-background-50 mb-4">合作伙伴</h3>
            <p className="text-sm text-foreground-500 mb-4">诚邀优质内容平台与品牌方合作，共同打造一流爆料生态。</p>
            <a
              href="#contact"
              className="inline-flex items-center px-5 py-2.5 bg-primary-500 text-background-50 rounded-lg text-sm font-semibold hover:bg-primary-600 transition-colors whitespace-nowrap"
            >
              合作洽谈 <i className="ri-arrow-right-line ml-1"></i>
            </a>
          </div>
        </div>

        <div className="border-t border-foreground-800 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} 爆料网 - 每日吃瓜爆料最新入口。本站内容仅供信息参考，不构成任何建议。
          </p>
          <div className="flex items-center gap-4 text-xs text-foreground-500">
            <a href="#hero" className="hover:text-primary-400 transition-colors">用户协议</a>
            <a href="#hero" className="hover:text-primary-400 transition-colors">隐私政策</a>
            <a href="#hero" className="hover:text-primary-400 transition-colors">免责声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}